export default {
  currentBoard(state) {
    return state.currentBoard;
  }
};
